import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TemplateRenderer } from './PortfolioTemplates';

const PublicPortfolioPage = () => {
  const { slug } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/portfolio/public/${slug}`)
      .then(r => {
        if (r.status === 404) { setNotFound(true); return null; }
        return r.json();
      })
      .then(d => { if (d) setData(d); })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug, API_BASE_URL]);

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0a0a12', color: '#e0a3ff', fontFamily: 'system-ui, sans-serif', fontSize: '1rem' }}>
      Loading portfolio…
    </div>
  );

  if (notFound || !data) return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0a0a12', color: '#e0a3ff', fontFamily: 'system-ui, sans-serif', textAlign: 'center', gap: 12 }}>
      <span style={{ fontSize: '3rem' }}>🔍</span>
      <h2 style={{ margin: 0 }}>Portfolio not found</h2>
      <p style={{ color: 'rgba(224,163,255,0.5)', margin: 0 }}>This link may have expired or doesn't exist.</p>
      <a href="/" style={{ marginTop: 8, color: '#e0a3ff', fontSize: '0.9rem' }}>← Go to Terview</a>
    </div>
  );

  return (
    <div style={{ position: 'relative' }}>
      <TemplateRenderer template={data.template} profile={data.profile} />

      {/* Terview badge */}
      <a
        href="/"
        target="_blank"
        rel="noreferrer"
        style={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          background: 'rgba(10,10,18,0.9)',
          border: '1px solid rgba(224,163,255,0.3)',
          borderRadius: 24,
          padding: '6px 14px',
          fontSize: '0.75rem',
          color: '#e0a3ff',
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          backdropFilter: 'blur(10px)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
          zIndex: 9999,
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        <span style={{ fontSize: '0.9rem' }}>🎯</span> Built with terview.ai
      </a>
    </div>
  );
};

export default PublicPortfolioPage;
